module.exports = __webpack_public_path__ + "static/privacy_policy-7bc2750395ca90d9dc714aa2c48a4adf.pdf";